/* global axios */
import ApiClient from './ApiClient';

export const buildContactParams = (page, sortAttr, label, search) => {
  let params = `include_contact_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${label}`;
  }
  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}?${buildContactParams(
      page,
      sortAttr,
      label,
      ''
    )}`;
    return axios.get(requestURL);
  }

  show(id) {
    return axios.get(`${this.url}/${id}?include_contact_inboxes=false`);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}?include_contact_inboxes=false`, data);
  }

  getConversations(contactId) {
    return axios.get(`${this.url}/${contactId}/conversations`);
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  initiateCall(contactId, inboxId) {
    return axios.post(`${this.url}/${contactId}/call`, {
      inbox_id: inboxId,
    });
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  search(search = '', page = 1, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}/search?${buildContactParams(
      page,
      sortAttr,
      label,
      search
    )}`;
    return axios.get(requestURL);
  }

  active(page = 1, sortAttr = 'name') {
    let requestURL = `${this.url}/active?${buildContactParams(page, sortAttr)}`;
    return axios.get(requestURL);
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'name', queryPayload) {
    let requestURL = `${this.url}/filter?${buildContactParams(page, sortAttr)}`;
    return axios.post(requestURL, queryPayload);
  }

  importContacts(file, { segmentId, fieldMapping, notifyFlows } = {}) {
    const formData = new FormData();
    formData.append('import_file', file);
    if (segmentId) formData.append('segment_id', segmentId);
    if (notifyFlows) formData.append('notify_flows', '1');
    if (fieldMapping)
      formData.append('field_mapping', JSON.stringify(fieldMapping));
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  importPreview(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/import_preview`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  importCheck(file, fieldMapping) {
    const formData = new FormData();
    formData.append('import_file', file);
    formData.append('field_mapping', JSON.stringify(fieldMapping));
    return axios.post(`${this.url}/import_check`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  getImportTemplate() {
    return axios.get(`${this.url}/import_template`, {
      responseType: 'blob',
    });
  }

  destroyCustomAttributes(contactId, customAttributes) {
    return axios.post(`${this.url}/${contactId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  // Documentos da pessoa (identidade, carteirinha...): ficam no contato e todo
  // negocio futuro enxerga, sem copiar.
  documents(contactId) {
    return axios.get(`${this.url}/${contactId}/documents`);
  }

  uploadDocument(contactId, file, label = '') {
    const fd = new FormData();
    fd.append('document', file);
    if (label) fd.append('label', label);
    return axios.post(`${this.url}/${contactId}/upload_document`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroyDocument(contactId, attachmentId) {
    return axios.delete(`${this.url}/${contactId}/documents/${attachmentId}`);
  }

  destroyAvatar(contactId) {
    return axios.delete(`${this.url}/${contactId}/avatar`);
  }

  exportContacts(queryPayload) {
    return axios.post(`${this.url}/export`, queryPayload);
  }

  getTouchpoints(contactId) {
    return axios.get(`${this.url}/${contactId}/touchpoints?per=50`);
  }
}

export default new ContactAPI();
